<!-- @format -->

<template>
	<el-input v-model="value" :maxlength="options.maxLength || 50" show-word-limit></el-input>
</template>

<script setup lang="ts">
	interface Props {
		modelValue: string | null;
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
